import React, { createContext, useContext, useState } from "react"

interface MicrophoneContextType {
  isListening: boolean
  setIsListening: (listening: boolean) => void
  isLoading: boolean
  setIsLoading: (loading: boolean) => void
}

const MicrophoneContext = createContext<MicrophoneContextType | null>(null)

export const MicrophoneProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [isListening, setIsListening] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const value = {
    isListening,
    setIsListening,
    isLoading,
    setIsLoading,
  }

  return <MicrophoneContext.Provider value={value}>{children}</MicrophoneContext.Provider>
}

export const useMicrophone = (): MicrophoneContextType => {
  const context = useContext(MicrophoneContext)
  if (!context) {
    throw new Error("useMicrophone must be used within a MicrophoneProvider")
  }
  return context
}
